import { PaginationPage } from 'models'
import { STORAGE_TOKEN_KEY } from '../configs/constant'
import { PdfJs } from 'core/types'
import { getPage } from 'core/utils/managePages'
// bind url with params
export const bindParams = (str: string, params: any = {}) => {
  let result = str
  for (const key in params) {
    result = result.replace(new RegExp(`:${key}`, 'g'), params[key])
  }
  return result
}

export const scrollToErrorField = ({ errorFields }: any) => {
  const el = document.getElementById(errorFields[0].name[0]) as HTMLElement
  el.scrollIntoView()
  window.scrollTo(0, window.scrollY - el.offsetHeight - 300)
}

export const checkLogin = () => {
  return !!localStorage.getItem(STORAGE_TOKEN_KEY)
}

export const jumpToPageTrial = (pagesTrial: number[], pageCurrent: number, type: PaginationPage, jumpToPage: (pageIndex: number) => void) => {
  const pageCurrentIndex = pagesTrial.findIndex((page: number) => page === pageCurrent)
  if (type === PaginationPage.NEXT) {
    const nextPage = pagesTrial[pageCurrentIndex + 1]
    // page index in pdf file
    return jumpToPage(nextPage - 1)
  } else if (type === PaginationPage.PREV && pageCurrentIndex !== 0) {
    const prevPage = pagesTrial[pageCurrentIndex - 1]
    // page index in pdf file
    return jumpToPage(prevPage - 1)
  }
}

export const changePageTrial = (pagesTrial: number[], pageChange: any) => {
  if (pagesTrial.includes(pageChange)) {
    return pageChange
  }
  return
}

export const readFileTxt = (fileUrl: string, callback: any) => {
  fetch(fileUrl)
    .then((res) => res.text())
    .then((text) => {
      callback(text)
    })
    // eslint-disable-next-line no-console
    .catch((e) => console.error(e))
}

export const convertPdfPageToImage = async (doc: PdfJs.PdfDocument, pageIndex: number) => {
  const pdfPage = await getPage(doc, pageIndex)
  const scale = 1
  const viewport = pdfPage.getViewport({ scale })
  const outputScale = window.devicePixelRatio || 1

  const canvas = document.createElement('canvas')
  const context = canvas.getContext('2d')

  canvas.width = Math.floor(viewport.width * outputScale)
  canvas.height = Math.floor(viewport.height * outputScale)
  canvas.style.width = Math.floor(viewport.width) + 'px'
  canvas.style.height = Math.floor(viewport.height) + 'px'

  const transform = outputScale !== 1 ? [outputScale, 0, 0, outputScale, 0, 0] : null
  const renderContext = {
    canvasContext: context,
    transform,
    viewport
  } as any
  await pdfPage.render(renderContext).promise
  return canvas.toDataURL('image/png')
}
export const expandRange = (range: string): number[] => {
  const [start, end] = range.split('-').map(Number)
  return Array.from({ length: end - start + 1 }, (_, i) => start + i)
}

export const parseStringToArray = (str: string): number[] => {
  return str.split(',').flatMap((part) => (part.includes('-') ? expandRange(part) : [Number(part)]))
}

export const toASCII = (chars: string): string => {
  // convert if input is text fullwidth
  const fullwidthToHalfwidth: { [key: string]: string } = {
    '０': '0', '１': '1', '２': '2', '３': '3', '４': '4',
    '５': '5', '６': '6', '７': '7', '８': '8', '９': '9',
    '！': '!', '＠': '@', '＃': '#', '＄': '$', '％': '%',
    '＾': '^', '＆': '&', '＊': '*', '（': '(', '）': ')',
    '＿': '_', '＋': '+', '－': '-', '＝': '=', '｛': '{',
    '｝': '}', '［': '[', '］': ']', '｜': '|', '＼': '\\',
    // eslint-disable-next-line quotes
    '：': ':', '；': ';', '＇': "'", '＂': '"', '＜': '<',
    '＞': '>', '，': ',', '．': '.', '／': '/', '？': '?',
    '～': '~', '　': ' '
  }

  let ascii = ''

  for (let i = 0; i < chars.length; i++) {
    const char = chars[i]
    ascii += fullwidthToHalfwidth[char] || char
  }

  return ascii

}


export const isFullwidth = (text: string) => {
  const regex = /^[\uFF01-\uFF5E\uFF61-\uFF65]+$/
  return regex.test(text)
}

export const isNumber = (text: string) => {
  const regex = /^\d*$/
  return regex.test(text)
}

export const getCookie = (name: string): string | null => {
  const nameEQ = name + '='
  const cookies = document.cookie.split(';')

  for (let i = 0; i < cookies.length; i++) {
    const cookie = cookies[i].trim()
    if (cookie.indexOf(nameEQ) === 0) {
      return cookie.substring(nameEQ.length, cookie.length)
    }
  }
  return null // Return null if the cookie is not found
}

export const isPointInRect = ({ x, y, width, height, px, py }: { px: number; py: number; x: number; y: number; width: number; height: number }) => {
  return px >= x && px <= x + width && py >= y && py <= y + height
}